var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-page" }, [
    _c("div", { staticClass: "fc-text-center fc-mar-t-super" }, [
      _vm.isInRealLive
        ? _c("img", {
            staticClass: "logo_img_reallive",
            attrs: { src: require("../../../static/img/realLive.png") }
          })
        : _vm.isInBondo
        ? _c("img", {
            staticClass: "logo_img_reallive",
            attrs: { src: require("../../../static/img/bondo.png") }
          })
        : _c("img", {
            staticClass: "logo_img",
            attrs: { src: require("../../assets/img/logo.png") }
          })
    ]),
    _vm._v(" "),
    !_vm.isInBuzzCast
      ? _c("div", { staticClass: "login_box" }, [
          _c(
            "div",
            {
              staticClass: "login-btn__reallive",
              class: { "bondo-phone-login": _vm.isInBondo },
              on: { click: _vm.phoneLogin }
            },
            [
              !_vm.isInBondo
                ? _c("img", {
                    staticClass: "login_icon__reallive",
                    attrs: { src: require("../../assets/img/phone.png") }
                  })
                : _c("img", {
                    staticClass: "login_icon__reallive",
                    attrs: { src: require("../../assets/img/phone_bondo.png") }
                  }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("m.use_phone_login")))])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "login-btn__reallive login-btn__reallive__email",
              class: { "bondo-email-login": _vm.isInBondo },
              on: { click: _vm.emailLogin }
            },
            [
              !_vm.isInBondo
                ? _c("img", {
                    staticClass: "login_icon__reallive",
                    attrs: { src: require("../../assets/img/email.png") }
                  })
                : _c("img", {
                    staticClass: "login_icon__reallive",
                    attrs: { src: require("../../assets/img/email_bondo.png") }
                  }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("m.use_email_login")))])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isTgWebApp && _vm.isInBuzzCast
      ? _c(
          "div",
          { staticClass: "login_box" },
          [
            _c("login-sdk-facebook", { attrs: { styleType: "bar" } }),
            _vm._v(" "),
            _c("login-sdk-google", { attrs: { styleType: "bar" } }),
            _vm._v(" "),
            _c("div", { staticClass: "btn_split" }, [
              _c("span", { staticClass: "btn_split_line" }),
              _vm._v(" "),
              _c("span", { staticClass: "btn_split_txt" }, [
                _vm._v(_vm._s(_vm.$t("m.or")))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "btn_split_line" })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "login_other" },
              [
                _vm.thisLangcountry == "ru" ? _c("login-sdk-vk") : _vm._e(),
                _vm._v(" "),
                _vm.thisLangcountry !== "zh"
                  ? _c("login-sdk-twitter")
                  : _vm._e(),
                _vm._v(" "),
                _vm.thisLangcountry !== "zh" && _vm.thisLangcountry !== "ru"
                  ? _c("login-sdk-line")
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "img_box", on: { click: _vm.phoneLogin } },
                  [
                    _c("img", {
                      staticClass: "login_other_img",
                      attrs: {
                        src: require("../../assets/img/h5_login_icon05.png")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "img_box", on: { click: _vm.emailLogin } },
                  [
                    _c("img", {
                      staticClass: "login_other_img",
                      attrs: {
                        src: require("../../assets/img/h5_login_icon06.png")
                      }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isTgWebApp && _vm.isInBuzzCast
      ? _c("div", { staticClass: "login_box" }, [
          _c(
            "div",
            { staticClass: "tglogin_box", on: { click: _vm.phoneLogin } },
            [
              _c("img", {
                staticClass: "login_other_img_tg",
                attrs: { src: require("../../assets/img/h5_login_phone.png") }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("m.use_phone_login")))])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tglogin_box", on: { click: _vm.emailLogin } },
            [
              _c("img", {
                staticClass: "login_other_img_tg",
                attrs: { src: require("../../assets/img/h5_login_email.png") }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("m.use_email_login")))])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31d576c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31d576c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/LoginSdk.vue
// module id = null
// module chunks = 